import { useNavigate, useParams } from 'react-router-dom'

import { Box, Link, Text } from '@factorialco/deprecated-design-system'
import { capitalize } from 'lodash'

import Selector from 'modules/core/components/Selector'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const NoEmployeeAssignationSelectInfo = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { id: projectId } = useParams()

  const value: string[] = []

  return (
    <Selector.Popover
      label={i18n.t('project_management.tasks.form.labels.assignees')}
      placeholder={i18n.t('common.select_multiple')}
      blankLabel={capitalize(i18n.t('common.empty'))}
      onChange={() => {}}
      value={[]}
      footer={
        <Box
          padding="s24"
          width="full"
          border={{ all: { color: 'viridian100', style: 'solid', width: 's1' } }}
          borderRadius={{ all: 'abs008' }}
          background="viridian100"
        >
          <Text.Normal>
            {i18n.t('project_management.tasks.form.labels.empty_assignees.label')}
          </Text.Normal>
          <Box gap="s8" paddingTop="s8" justifyContent="flexStart">
            <Link.Touchable
              onClick={() => {
                navigate(
                  navigation.projects.id.details.employees.workers.fullPath({
                    id: String(projectId),
                  }),
                  {
                    replace: true,
                  }
                )
              }}
            >
              {i18n.t('project_management.tasks.form.labels.empty_assignees.link')}
            </Link.Touchable>
          </Box>
        </Box>
      }
    >
      {value.map((v) => (
        <Selector.Option key={v} value={v} label={v} searchValue={v}>
          {v}
        </Selector.Option>
      ))}
    </Selector.Popover>
  )
}

export default NoEmployeeAssignationSelectInfo
